import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Crown, Check, TrendingUp } from 'lucide-react';
export function InvestmentSection() {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });
  return <section className="relative py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-black" data-id="element-1098">
      <motion.div ref={ref} initial={{
      opacity: 0,
      y: 30
    }} animate={inView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto" data-id="element-1099">
        <div className="text-center mb-12 sm:mb-16" data-id="element-1100">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-serif font-bold text-stone-100 mb-6 sm:mb-8" style={{
          fontFamily: 'Cinzel, serif'
        }} data-id="element-1101">
            Your Investment
          </h2>
          <p className="text-lg sm:text-xl text-stone-400 max-w-2xl mx-auto" data-id="element-1102">
            Choose the path that works best for you. Both options include full
            Founding Member benefits.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 max-w-5xl mx-auto" data-id="element-1103">
          {/* Monthly Option */}
          <div className="bg-stone-900/50 border border-stone-800 p-6 sm:p-8 rounded-xl hover:border-stone-600 transition-colors" data-id="element-1104">
            <h3 className="text-xl sm:text-2xl font-bold text-stone-100 mb-2" data-id="element-1105">
              Monthly Membership
            </h3>
            <div className="flex items-baseline gap-2 mb-6" data-id="element-1106">
              <span className="text-3xl sm:text-4xl font-bold text-amber-500" data-id="element-1107">
                $220
              </span>
              <span className="text-stone-400" data-id="element-1108">/month</span>
            </div>
            <ul className="space-y-3 sm:space-y-4 mb-8" data-id="element-1109">
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1110">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1111" />
                <span data-id="element-1112">Full Access to PSI PRO</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1113">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1114" />
                <span data-id="element-1115">Peptide Mastery 2.0 Included</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1116">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1117" />
                <span data-id="element-1118">Live Monthly Sessions</span>
              </li>
            </ul>
            <a href="https://go.peptidescienceinstitute.com/pm-pro-monthly-fm" className="block w-full py-3 sm:py-4 text-center border border-amber-500 text-amber-500 font-bold rounded-lg hover:bg-amber-500 hover:text-black transition-all duration-300 min-h-[44px]" data-id="element-1119">
              Join Monthly
            </a>
          </div>

          {/* Annual Option */}
          <div className="relative bg-gradient-to-br from-amber-950/40 to-black border-2 border-amber-500 p-6 sm:p-8 rounded-xl shadow-[0_0_30px_rgba(217,119,6,0.2)]" data-id="element-1120">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-black px-4 py-1 rounded-full text-xs sm:text-sm font-bold" data-id="element-1121">
              BEST VALUE
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-stone-100 mb-2" data-id="element-1122">
              Annual Membership
            </h3>
            <div className="flex items-baseline gap-2 mb-6" data-id="element-1123">
              <span className="text-3xl sm:text-4xl font-bold text-amber-500" data-id="element-1124">
                $2,200
              </span>
              <span className="text-stone-400" data-id="element-1125">/year</span>
            </div>
            <ul className="space-y-3 sm:space-y-4 mb-8" data-id="element-1126">
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1127">
                <Crown className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-1128" />
                <span className="font-bold text-white" data-id="element-1129">2 Months FREE</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1130">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1131" />
                <span data-id="element-1132">Full Access to PSI PRO</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1133">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1134" />
                <span data-id="element-1135">Peptide Mastery 2.0 Included</span>
              </li>
              <li className="flex items-start gap-3 text-stone-300 text-sm sm:text-base" data-id="element-1136">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-1137" />
                <span data-id="element-1138">Live Monthly Sessions</span>
              </li>
            </ul>
            <a href="https://go.peptidescienceinstitute.com/pm-pro-annual-fm" className="block w-full py-3 sm:py-4 text-center bg-amber-500 text-black font-bold rounded-lg hover:bg-amber-400 transition-all duration-300 shadow-lg hover:shadow-amber-500/25 min-h-[44px]" data-id="element-1139">
              Join Annual & Save
            </a>
          </div>
        </div>
      </motion.div>
    </section>;
}